import { HttpErrorResponse, type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { AuthService } from '../shell/auth/auth.service';

/**
Standalone-only: sends the browser to Keycloak's login page on a 401.

A 401 past `authInterceptor` means the token it attached was rejected
(expired beyond refresh, revoked, or otherwise invalid) — re-authenticating
through Keycloak is the only way to recover, same as an unauthenticated
request would. Registered solely in `main.ts`'s interceptor chain, never in
`app.config.ts`'s federated one — a whole-page redirect triggered from
inside this MFE would be exactly the kind of global effect the federated
build must never introduce (see `app.config.ts`'s own comment on why it
avoids `provideBrowserGlobalErrorListeners()`).
@param request - Outgoing request.
@param next - Next handler in the interceptor chain.
@returns The handler's stream, redirecting to login first on a 401.
*/
export const sessionExpiredInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);

  return next(request).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        void authService.login();
      }

      return throwError(() => error);
    }),
  );
};
